import React from 'react';
import Anime from 'react-anime';
import './ImageCircle.scss';
import image3 from '../assets/elements/img/chapter-34-image.png';
export default ({ imgSrc=image3, position='', hideMobile=false}) => {
  const scaleImage = {
    scale: [
      { value: 0, duration: 0 },
      { value: 1, duration: 1000, easing: 'linear', delay: 1000}
    ]
  }
  return (
      <Anime {...scaleImage} className={`image-circle ${position} ${hideMobile? 'hide-desktop' : ''}`}>
        <img src={imgSrc} alt="woman" />
      </Anime>
  );
};